<template>
  <ValidationObserver
    ref="observer"
    v-slot="{ valid, dirty }"
  >
    <v-col class="modalColPadding">
      <p class="modalXMargin titleModal">
        {{ $t('forms.labels.name') }}
      </p>
    </v-col>
    <v-row class="modalXMargin">
      <v-col
        class="modalColPadding"
        cols="12"
        sm="4"
      >
        <VTextField
          v-model="data.firstName"
          outlined
          :label="$t('forms.labels.firstName')"
          :rules="{ required: true, min: 1, max: 200 }"
          :disabled="!isEditable"
          data-cy="addContact-firstName"
        />
      </v-col>
      <v-col
        class="modalColPadding"
        cols="12"
        sm="4"
      >
        <VTextField
          v-model="data.secondFirstName"
          outlined
          :label="$t('forms.labels.secondFirstName')"
          :rules="{ max: 200 }"
          :disabled="!isEditable"
          data-cy="addContact-secondName"
        />
      </v-col>
      <v-col
        class="modalColPadding"
        cols="12"
        sm="4"
      >
        <VTextField
          v-model="data.lastName"
          outlined
          :label="$t('forms.labels.lastName')"
          :rules="{ required: true, min: 1, max: 200 }"
          :disabled="!isEditable"
          data-cy="addContact-lastName"
        />
      </v-col>
    </v-row>
    <v-col class="modalColPadding">
      <p class="modalXMargin titleModal">
        {{ $t('forms.labels.phone') }}
      </p>
    </v-col>
    <v-col class="modalColPadding">
      <p class="modalXMargin subtitleModal">
        {{ $t('forms.labels.phone') }}
      </p>
    </v-col>
    <v-row class="modalXMargin">
      <v-col
        class="modalColPadding"
        style="padding-bottom:5px;"
        cols="12"
        sm="8"
      >
        <PhoneNumberInput
          :refObserver="$refs.observer"
          :value="data.phoneNumber.number"
          :disabled="!isEditable"
          :isPhoneNumberValid="data.isPhoneNumberValid"
          :required="data.mainContact"
          data-cy="addContact-phoneNumber"
          @inputChanged="phoneInput"
        />
      </v-col>
      <v-col
        class="modalColPadding"
        cols="12"
        sm="4"
      >
        <VTextField
          v-model="data.phoneExtension"
          outlined
          :label="$t('forms.labels.extension')"
          :rules="{max: 10}"
          type="number"
          :disabled="!isEditable"
          data-cy="addContact-extention"
        />
      </v-col>
    </v-row>
    <v-col class="modalColPadding">
      <p class="modalXMargin subtitleModal">
        {{ $t('forms.labels.cellPhoneNumber') }}
      </p>
    </v-col>
    <v-row class="modalXMargin">
      <v-col
        class="modalColPadding"
        style="padding-bottom:5px;"
        cols="12"
        sm="12"
      >
        <PhoneNumberInput
          :refObserver="$refs.observer"
          :value="data.cellPhoneNumber.number"
          :disabled="!isEditable"
          :phonePlaceholder="'forms.labels.cellPhoneNumber'"
          :isPhoneNumberValid="data.isCellPhoneNumberValid"
          data-cy="addContact-cellPhoneNumber"
          @inputChanged="cellPhoneInput"
        />
      </v-col>
    </v-row>
    <v-col class="modalColPadding">
      <p class="modalXMargin subtitleModal">
        {{ $t('forms.labels.faxNumber') }}
      </p>
    </v-col>
    <v-row class="modalXMargin">
      <v-col
        class="modalColPadding"
        style="padding-bottom:5px;"
        cols="12"
        sm="12"
      >
        <PhoneNumberInput
          :refObserver="$refs.observer"
          :value="data.faxNumber"
          :disabled="!isEditable"
          :phonePlaceholder="'forms.labels.faxNumber'"
          :isPhoneNumberValid="data.isFaxNumberValid"
          data-cy="addContact-faxNumber"
          @inputChanged="faxPhoneInput"
        />
      </v-col>
    </v-row>
    <v-col class="modalColPadding">
      <p class="modalXMargin titleModal">
        {{ $t('forms.labels.address') }}
      </p>
    </v-col>
    <v-row class="modalXMargin">
      <v-col class="modalColPadding">
        <AutocompleteAdresse
          @change="updateDatas"
        />
      </v-col>
    </v-row>
    <v-row class="modalXMargin">
      <v-col class="modalColPadding">
        <AddressFormPart
          :details="addressDetails"
          :isEditable="isEditable"
          :adressWithAutocomplete="true"
          @change="onChangeAddress"
        />
      </v-col>
    </v-row>
    <v-col class="modalColPadding">
      <p class="modalXMargin titleModal">
        {{ $t('forms.labels.email') }}
      </p>
    </v-col>
    <v-row class="modalXMargin">
      <v-col class="modalColPadding">
        <VTextField
          v-model="data.email"
          outlined
          :label="$t('forms.labels.email')"
          :rules="{ required: isEmailRequired, max: 200, email: true }"
          :disabled="!isEditable"
          data-cy="addContact-email"
        />
      </v-col>
    </v-row>
    <v-col class="modalColPadding">
      <p class="modalXMargin titleModal">
        {{ $t('forms.labels.job') }}
      </p>
    </v-col>
    <v-row class="modalXMargin">
      <v-col
        class="modalColPadding"
        cols="12"
        sm="6"
      >
        <VTextField
          v-model="data.jobTitle"
          outlined
          :label="$t('forms.labels.jobTitle')"
          :rules="{ required: true, min: 1, max: 200 }"
          :disabled="!isEditable"
          data-cy="addContact-jobTitle"
        />
      </v-col>
      <v-col
        class="modalColPadding"
        cols="12"
        sm="6"
      >
        <VTextField
          v-model="data.professionalTitle"
          outlined
          :label="$t('forms.labels.professionalTitle')"
          :rules="{ max: 200 }"
          :disabled="!isEditable"
        />
      </v-col>
    </v-row>

    <v-row class="modalXMargin">
      <v-col class="modalColPadding">
        <VCheckbox
          v-model="data.mainContact"
          outlined
          :label="$t('forms.labels.mainContact')"
          :disabled="!isEditable"
          data-cy="addContact-boxMainContact"
        />
      </v-col>
    </v-row>
    <div class="modalXMargin line-checkbox">
      <v-col
        class="modalColPadding"
      >
        <VCheckbox
          v-model="data.receiveLabReport"
          outlined
          :label="$t('contacts.labels.receiveLabReport')"
          :disabled="!isEditable"
        />
      </v-col>
      <v-col
        class="modalColPadding"
      >
        <VCheckbox
          v-model="data.receiveServiceReport"
          outlined
          :label="$t('contacts.labels.receiveServiceReport')"
          :disabled="!isEditable"
        />
      </v-col>
    </div>
    <v-col class="modalColPadding">
      <p class="modalXMargin titleModal">
        {{ $t('forms.labels.notes') }}
      </p>
    </v-col>
    <v-row class="modalXMargin">
      <v-col class="modalColPadding">
        <VTextarea
          v-model="data.notes"
          outlined
          :label="$t('forms.labels.notes')"
          :rules="{ max: 200 }"
          :disabled="!isEditable"
        />
      </v-col>
    </v-row>

    <SlotScopeWatcher
      :value="dirty"
      @change="$emit('dirtyChanged', dirty)"
    />
    <SlotScopeWatcher
      :value="valid"
      @change="$emit('validChanged', valid)"
    />
  </ValidationObserver>
</template>

<script>
import { mapGetters } from 'vuex';
import { isEmpty, pick } from 'lodash';
import { ValidationObserver } from 'vee-validate';
import SlotScopeWatcher from '@/components/shared/widgets/forms/validationHelper/SlotScopeWatcher';
import VTextarea from '@/components/shared/widgets/forms/VuetifyInputs/VTextarea.vue';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import AddressFormPart from '@/components/shared/forms-controls/AddressFormPart.vue';
import VCheckbox from '@/components/shared/widgets/forms/VuetifyInputs/VCheckbox';
import PhoneNumberInput from '@/components/shared/widgets/forms/PhoneNumberInput.vue';
import AutocompleteAdresse from '../AutocompleteAdresse.vue';

export default {
    components: {
        AddressFormPart,
        SlotScopeWatcher,
        VCheckbox,
        VTextField,
        VTextarea,
        ValidationObserver,
        PhoneNumberInput,
        AutocompleteAdresse,
    },
    props: {
        populateWith: {
            type: Object,
            default: () => ({ empty: true }),
        },
        isEditable: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            data: {
                client: this.$route.params.clientId,
                site: this.$route.params.siteId ? this.$route.params.siteId : null,
                firstName: null,
                lastName: null,
                email: null,
                secondFirstName: null,
                jobTitle: null,
                professionalTitle: null,
                phoneNumber: { number: '' },
                phoneExtension: null,
                cellPhoneNumber: { number: '' },
                faxNumber: null,
                address: null,
                province: null,
                country: null,
                city: null,
                postalCode: null,
                streetNumber: null,
                notes: null,
                mainContact: false,
                isPhoneNumberValid: true,
                isCellPhoneNumberValid: true,
                isFaxNumberValid: true,
            },
        };
    },
    computed: {
        ...mapGetters([
            'client',
            'site',
        ]),
        addressDetails() {
            return {
                address: this.data.address,
                city: this.data.city,
                country: this.data.country,
                postalCode: this.data.postalCode,
                province: this.data.province,
                streetNumber: this.data.streetNumber,
                appartmentNumber: this.data.appartmentNumber,
            };
        },
        isEmailRequired() {
            return this.data.mainContact || this.data.receiveLabReport || this.data.receiveServiceReport || false;
        },
    },
    watch: {
        populateWith: {
            handler() {
                if (!this.populateWith.empty) {
                    this.data = this.populateWith;
                    this.data.phoneNumber = this.populateWith.phoneNumber ? this.populateWith.phoneNumber : { number: '' };
                    this.data.cellPhoneNumber = this.populateWith.cellPhoneNumber ? this.populateWith.cellPhoneNumber : { number: '' };
                }
            },
            immediate: true,
        },
        data: {
            handler() {
                this.updateData();
            },
            deep: true,
        },
    },
    created() {
        this.getAddress();
    },
    methods: {
        getAddress() {
            const parent = isEmpty(this.site) ? 'client' : 'site';
            if (this.isEditable && this.populateWith.empty) {
                this.data = {
                    ...this.data,
                    ...pick(this[parent], ['address', 'city', 'country', 'postalCode', 'province', 'streetNumber']),
                };
            }
        },
        updateData() {
            this.$emit('sendData', this.data);
        },
        onChangeAddress(details) {
            this.data = {
                ...this.data,
                ...details,
            };
        },
        cellPhoneInput(number, payload) {
            this.data.cellPhoneNumber = !number ? {} : payload;
            this.data.isCellPhoneNumberValid = payload.valid;
            this.updateData();
        },
        faxPhoneInput(number, payload) {
            this.data.faxNumber = number ?? payload.number;
            this.data.isFaxNumberValid = payload.valid;
            this.updateData();
        },
        phoneInput(number, payload) {
            this.data.phoneNumber = !number ? {} : payload;
            this.data.isPhoneNumberValid = payload.valid;
            this.updateData();
        },
        updateDatas(adress) {
            if (!isEmpty(adress)) {
                this.data = {
                    ...this.data,
                    city: adress?.locality || adress?.sublocality_level_1 || adress?.administrative_area_level_3 || '',
                    country: adress?.country || '',
                    province: adress?.administrative_area_level_1 || '',
                    postalCode: adress?.postal_code || adress?.postal_code_prefix || '',
                    streetNumber: adress?.street_number || '',
                    address: adress?.route || '',
                };
            }
        },
    },
};
</script>
<style scoped lang="scss">
.line-checkbox{
  display: flex;
  flex-direction: row;
}
  @media screen and (max-width: 600px) {
    .line-checkbox{
      flex-direction: column;
    }
  }
</style>
